import { Controller } from '@hotwired/stimulus'
import debounce from 'debounce'

export default class extends Controller {
  static values = {
    debounceDuration: { type: Number, default: 150 }
  }

  initialize () {
    this.submit = debounce(this.submit, this.debounceDurationValue)
  }

  submit (event) {
    this.element.requestSubmit()
  }
}
